export class EndTurnRequest {
    static Message = 'EndTurnRequest';
}

export class EndTurnResponse {
    static Message = 'EndTurnResponse';

    public winnerId: string;

    constructor(winnerId: string) {
        this.winnerId = winnerId;
    }
}
